import { LootBoxSpriteInfo, TILE_SIZE } from "../models/common";
import { SpriteLoader } from "../sprite-loader";

// Helper method to determine the appropriate sprite for a loot bag based on its contents
export const getLootBagSprite = (
  scene: Phaser.Scene,
  lootBagSpriteInfo: LootBoxSpriteInfo,
): Phaser.GameObjects.Image => {
  const px = lootBagSpriteInfo.x * TILE_SIZE + TILE_SIZE / 2;
  const py = lootBagSpriteInfo.y * TILE_SIZE + TILE_SIZE / 2;

  // If it's an air drop chest, use airdrop-box sprite
  if (lootBagSpriteInfo.isAirDrop) {
    return scene.add.image(px, py, "airdrop-box");
  }
  // If there's exactly one item, show that item's sprite
  return SpriteLoader.createSprite(
    scene,
    lootBagSpriteInfo.spriteSheet,
    lootBagSpriteInfo.spriteX,
    lootBagSpriteInfo.spriteY,
    px,
    py,
    false,
  );
};
